import React, { useContext, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { Accordion, Icon, Transition } from 'semantic-ui-react'
import { StyledAccordion } from '~/pages/Farmer/Faq/style'
import { CoolFarmOptionsContext } from '../../..'
import ManureType from './ManureType'
import { StyledHerdGroupsWrapper } from '../../Feed/style'
import { formatNumber } from '~/utils/helpers'

const ManureTypes:React.FC = () => {
  const { control } = useFormContext()
  const options = useContext(CoolFarmOptionsContext)

  const herdGroups = useWatch({ control, name: 'herdGroups' }) || []
  const herdCategoryOptions = options?.herdCategories || []

  const [activeIndexes, setActiveIndexes] = useState<number[]>(herdGroups.map((group, index) => index))

  const handleAccordionClick = (index: number) => {
    const currentIndex = activeIndexes.indexOf(index)
    const newIndexes = [...activeIndexes]

    if (currentIndex > -1) {
      newIndexes.splice(currentIndex, 1)
    } else {
      newIndexes.push(index)
    }

    setActiveIndexes(newIndexes)
  }

  function renderHerdGroups() {
    return <>
      {herdGroups.map((herdGroup, herdIndex) => {
        const category = herdCategoryOptions.find(cat => cat.id === herdGroup.herdCategoryId)
        const isActive = activeIndexes.includes(herdIndex)

        if (!category) return null

        const manureStorageTypes = herdGroup?.manureStorageTypes || []
        const totalPercent = manureStorageTypes.reduce((sum, manure) => {
          const percent = parseFloat(manure?.percent) || 0
          return sum + percent
        }, 0)
        const isValid = totalPercent === 100
        const percentColor = isValid ? 'green' : 'red'

        return (
          <StyledAccordion key={herdGroup?.herdCategoryId} styled id={`manure-${herdGroup.id}`}>
            <Accordion.Title
              active={isActive}
              index={herdIndex}
              onClick={() => handleAccordionClick(herdIndex)}
              >
              <div>
                {`${category.label}`}
                {manureStorageTypes.length > 0 && (
                  <span style={{ marginLeft: '10px', color: percentColor, fontWeight: 'bold' }}>
                    ({formatNumber(totalPercent, 2)}%)
                  </span>
                )}
              </div>
              <Icon name={isActive ? 'minus' : 'plus'} />
            </Accordion.Title>

            <Transition visible={isActive} animation='slide down' duration={250}>
              <Accordion.Content active={isActive}>
                <ManureType herdIndex={herdIndex}/>
              </Accordion.Content>
            </Transition>
          </StyledAccordion>
        )
      })}
    </>
  }

  return <StyledHerdGroupsWrapper>
    {renderHerdGroups()}
  </StyledHerdGroupsWrapper>
}
export default ManureTypes